import { Component, OnInit, Input, Output, OnChanges, EventEmitter, SimpleChanges, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { ToastrService } from '../../../../shared/services/utilities/toastr.service';
import { Subscription } from 'rxjs';
import { FormCheckboxService } from '../../../../shared/services/utilities/form-checkbox.service';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { ProjectUtility, ProjectUtilityService } from '@adeo/ngx-kozikaza-api';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-kaza-edit-utilities',
  styleUrls: ['./kaza-edit-utilities.component.scss'],
  templateUrl: './kaza-edit-utilities.component.html'
})
@AutoUnsubscribe([])
export class KazaEditUtilitiesComponent extends OnDestroyComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() kazaForm: UntypedFormGroup;
  @Input() utilities: any;
  @Output() utilitiesFormatted: EventEmitter<any> = new EventEmitter<any>();

  projectUtilities: Array<ProjectUtility>;
  formArray: UntypedFormArray;
  private subscriptionKazaGetUtil: Subscription;

  constructor(
      private toastr: ToastrService,
      private projectUtilityService: ProjectUtilityService,
      private formCheckboxService: FormCheckboxService
  ) {
    super();
  }

  ngOnInit(): void {
    this.projectUtilities = Array<ProjectUtility>();

    this.initForm();
    this.loadProjectUtilities();
  }

  ngAfterViewInit(): void {
    this.watchControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.utilities && changes.utilities.currentValue && this.projectUtilities) {
      this.formCheckboxService.buildCheckbox(this.formArray, this.projectUtilities, this.utilities);
    }
  }

  initForm(): void {
    this.formArray = new UntypedFormArray([]);
    this.kazaForm.addControl('utilities', this.formArray);
  }

  watchControl(): void {
    this.kazaForm.get('utilities').valueChanges.subscribe(
        (data) => {
          this.utilitiesFormatted.emit(this.formCheckboxService.formatData(data, this.projectUtilities));
        }
    );
  }

  loadProjectUtilities(): void {
    this.subscriptionKazaGetUtil = this.projectUtilityService.getProjectUtilities().pipe(
        map((data) => data['hydra:member'])
    ).subscribe(
        data => {
          this.projectUtilities = data;
          this.formCheckboxService.buildCheckbox(this.formArray, this.projectUtilities, this.utilities);
        },
        err => this.toastr.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`)
    );
  }
}
